//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('consignmentSplitEdit', {
//        templateUrl: 'views/components/views/consignmentSplitEdit/consignmentSplitEdit.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'consignmentSplitEditService', 'rememberService', function ($stateParams, stateService, utilityService, translateService, modalService, consignmentSplitEditService, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let consignmentKeynoSplitFrom = $stateParams.consignment_keyno_splitfrom;
            
//            let variableNames = {
//                consignment_keyno_splitfrom: '',
//                gb_consignmentsplitedit: ''
//            };

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                bgConsignmentSplitEdit: {
//                    selected: 'LINE',
//                    buttons: [
//                        { id: 'LINE', label: 'gb_consignmentsplitedit_line', color: 'primary', onClick: () => setConsignmentSplitEditView('LINE') },
//                        { id: 'MANUAL', label: 'gb_consignmentsplitedit_manual', color: 'primary', onClick: () => setConsignmentSplitEditView('MANUAL') }
//                    ]
//                },
//                setting: {},
//                selectListPlans: [],
//                itemsListSplitEdits: [],
//                movingLines: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region BUTTON RADIO FUNCTIONS

//            function setConsignmentSplitEditView(id) {
//                vm.model.bgConsignmentSplitEdit.selected = vm.model.setting.gb_consignmentsplitedit = id;
//            }

//            // #endregion BUTTON RADIO FUNCTIONS

//            // #region LOAD PROCEDURE CALLS

//            async function loadSetting() {
//                vm.model.setting = (await consignmentSplitEditService.getSetting({ consignment_keyno_splitfrom: consignmentKeynoSplitFrom }))[0];
//            }

//            async function loadPlans() {
//                if (utilityService.validateParmsValue(vm.model.setting.consignment_keyno_splitfrom) !== true) return;

//                return vm.model.selectListPlans = await consignmentSplitEditService.listPlans({ consignment_keyno_splitfrom: vm.model.setting.consignment_keyno_splitfrom });
//            }

//            async function loadSplitEdits() {
//                if (utilityService.validateParmsValue(vm.model.setting.consignment_keyno_splitfrom) !== true) return;

//                return vm.model.itemsListSplitEdits = await consignmentSplitEditService.listSplitEdits({ consignment_keyno_splitfrom: vm.model.setting.consignment_keyno_splitfrom });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    switch (key) {
//                        case 'consignment_keyno_splitfrom':
//                            variableNames[key] = 'w_' + stateService.getCurrentName() + '_' + 'last' + '_' + key;
//                            break;
//                        case 'gb_consignmentsplitedit':
//                            variableNames[key] = 'gb_' + stateService.getCurrentName();
//                            break;
//                        default:
//                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                            break;
//                    }
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'consignment_keyno_splitfrom':
//                    case 'gb_consignmentsplitedit':
//                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region BUTTON RADIO FUNCTIONS

//            vm.selectBgConsignmentSplitEdit = function (value) {
//                vm.model.bgConsignmentSplitEdit.selected = value;
//                vm.model.setting.gb_consignmentsplitedit = vm.model.bgConsignmentSplitEdit.selected;

//                rememberFunc('gb_consignmentsplitedit');
//            }

//            // #endregion BUTTON RADIO FUNCTIONS

//            // #region TOGGLE FUNCTION

//            vm.toggleChosen = function (item) {
//                item = item?.item ? item.item : item;

//                if (item.item_id === '0') return;
//                if (item.item_id === '-1') return;

//                if (item.item_is_selected === '0') {
//                    item.item_is_selected = '1';
//                } else if (item.item_is_selected === '1') {
//                    item.item_is_selected = '0';
//                }
//            };

//            // #endregion TOGGLE FUNCTION

//            // #region BUTTON MOVE PROCEDURE FUNCTION CALL

//            vm.moveChanges = function () {
//                vm.model.movingLines = true;

//                let allData = vm.model.itemsListSplitEdits;
//                let selectedLines = [];

//                allData.forEach((item) => {
//                    selectedLines.push({
//                        item_id: item.item_id,
//                        item_is_selected: item.item_is_selected,
//                        quantity_total: item.quantity_total
//                    });
//                });

//                consignmentSplitEditService.moveLine({
//                    custact_no_consignmentplan: vm.model.setting.custact_no_consignmentplan,
//                    consignment_keyno_splitfrom: vm.model.setting.consignment_keyno_splitfrom,
//                    records: selectedLines
//                }).then(function (response) {
//                    if (response[0] && response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.movingLines = false;
//                                    loadSplitEdits();
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.movingLines = false;
//                        loadSplitEdits();
//                    }
//                });
//            }

//            // #endregion BUTTON MOVE PROCEDURE FUNCTION CALL

//            // #region ANGULAR LIFECYCLE FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadSetting();

//                setConsignmentSplitEditView(vm.model.setting.gb_consignmentsplitedit);

//                Promise.all([
//                    rememberFunc('consignment_keyno_splitfrom'),
//                    loadPlans()
//                ]).then(() => {
//                    loadSplitEdits();
//                    Promise.resolve();
//                });
//            }

//            // #endregion ANGULAR LIFECYCLE FUNCTION

//        }]
//    });
//})();
